"use client";

import { useState } from "react";
import "../globals.css";

export default function LoginPage() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault();
    setSubmitting(true);
    setError("");
    try {
      const r = await fetch("/api/auth/login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ username, password }),
      });
      if (!r.ok) {
        const t = await r.json().catch(() => ({}));
        setError(typeof t?.message === "string" ? t.message : "Login gagal");
        return;
      }
      window.location.href = "/";
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center p-6">
      <div className="w-full max-w-sm bg-cardbg border border-black/5 rounded-2xl p-6 shadow-[var(--shadow-soft)]">
        <h1 className="text-xl font-semibold text-primary text-center mb-5">Masuk</h1>
        <form onSubmit={onSubmit} className="space-y-4">
          <div>
            <input
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="Username"
              className="w-full rounded-lg border border-gray-300 px-4 py-3 outline-none focus:border-primary-light focus:ring-2 focus:ring-primary/20"
            />
          </div>
          <div>
            <input
              value={password}
              type="password"
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Password"
              className="w-full rounded-lg border border-gray-300 px-4 py-3 outline-none focus:border-primary-light focus:ring-2 focus:ring-primary/20"
            />
          </div>
          {error ? <div className="text-danger text-sm">{error}</div> : null}
          <button
            type="submit"
            disabled={submitting}
            className="w-full h-10 rounded-lg bg-accent hover:bg-accent-hover text-white text-sm font-medium transition -translate-y-0 hover:-translate-y-0.5 disabled:opacity-70"
          >
            {submitting ? "Memproses..." : "Masuk"}
          </button>
        </form>
      </div>
    </div>
  );
}